export default "__VITE_ASSET__Cdg1dgcpyxcx$poQ0ZLEuA__"